import { render, staticRenderFns } from "./TsHomeActivities.vue?vue&type=template&id=2d86d402&scoped=true"
import script from "./TsHomeActivities.vue?vue&type=script&lang=js"
export * from "./TsHomeActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86d402",
  null
  
)

export default component.exports